import { store } from '@redux/store'
import { ArrayToObject } from './misc'
import { getGameText } from './translation'
import { Decimal } from 'decimal.js'

const BET_TYPE_GAME_TYPE_CODE_ID = 3
const COMMON_RESULT_TYPE_CUSTOMIZE = 0
const COMMON_RESULT_TYPE_BET_AREA_SINGLE = 1
const COMMON_RESULT_TYPE_BET_AREA_MULTI = 2
const COMMON_RESULT_TYPE_TIME = 4

export function GetAreaDisplayText(gameCode, key) {
    return getGameText(key, gameCode)
}

export function IsBetTypeGame(gameCode) {
    const gameList = store.getState().dataService.gameList
    const gameMap = gameList ? ArrayToObject(gameList, 'game_code') : {}

    return gameMap[gameCode] && parseInt(gameMap[gameCode].code_id) === BET_TYPE_GAME_TYPE_CODE_ID
}

export function IsSupportSplitBetRecord(gameCode) {
    return BetAreaDisplay[gameCode] && CommonResultType[gameCode]
}

export function GetBetTypeGameAreaDisplay(gameCode, areaIdx) {
    return BetAreaDisplay[gameCode] ? (BetAreaDisplay[gameCode][areaIdx] ? GetAreaDisplayText(gameCode, BetAreaDisplay[gameCode][areaIdx]) : '') : ''
}

export function GetLotteryResultsDisplay(gameCode, areaIdx) {
    return LotteryResultsDisplay[gameCode] ? (LotteryResultsDisplay[gameCode][areaIdx] ? GetAreaDisplayText(`${gameCode}Result`, LotteryResultsDisplay[gameCode][areaIdx]) : '') : ''
}

export function GetBetTypeGameCommonResultDisplay(gameCode, commonResult, custom=false) {
    const type = CommonResultType[gameCode].type
    const key = CommonResultType[gameCode].key

    if (type === COMMON_RESULT_TYPE_CUSTOMIZE) {
        const result = commonResult[key]
            .map((elem) => {
                //return CommonResultValuesDisplay[gameCode][elem];
                return GetAreaDisplayText(gameCode, CommonResultValuesDisplay[gameCode][elem])
            })
        /** 電競色碟開解結果顯示JACKPOT */
        if (gameCode === 'CyberpunkColorDisc' && commonResult?.is_prize_jackpot) {
            const jpResult = `JACKPOT(${GetAreaDisplayText(gameCode, BetAreaDisplay[gameCode][Number(commonResult.prize_jackpot_area) + 6])})`
            result.push(jpResult)
        }
        return result.join(',')
    }

    if (type === COMMON_RESULT_TYPE_BET_AREA_SINGLE) {
        const startIdx = CommonResultType[gameCode].startIdx
        for (let i = startIdx; i < commonResult[key].length; i++) {
            if (commonResult[key][i]) return GetAreaDisplayText(gameCode, BetAreaDisplay[gameCode][i])
            //return BetAreaDisplay[gameCode][i];
        }
    }

    if (type === COMMON_RESULT_TYPE_BET_AREA_MULTI && commonResult[key] !== undefined) {
        const output = commonResult[key]
            .map((elem, idx) => {
                const gameCodeKey = CustomLotteryResultsDisplay.includes(gameCode) && custom ? `${gameCode}Result` : gameCode
                const displayKey = CustomLotteryResultsDisplay.includes(gameCode) && custom ? LotteryResultsDisplay[gameCode][idx] : BetAreaDisplay[gameCode][idx]
                let content = GetAreaDisplayText(gameCodeKey, displayKey)
                if (LuckyMultiplierGameList.includes(gameCode)) {
                    content = `${content}${LuckyMultiplier(commonResult, idx)}`
                }
                return elem ? content : null
            })
            .filter((elem) => elem !== null)
            .join(',')
        return output ? output : CommonResultType[gameCode].allFalseDisplay
    }

    if (type === COMMON_RESULT_TYPE_TIME) {
        if (gameCode === 'GarudaGod' || gameCode === 'AviatorX' || gameCode === 'Aviator') {
            // 遊戲局結果查詢&會員投注紀錄始用[0], 開獎結果查詢使用[1]
            const result = commonResult[key[0]] || commonResult[key[1]]
            return `${result}x`
        }
        return commonResult[key]
    }

    return ''
}

export function LuckyMultiplier(commonResult, idx) {
    return commonResult['lucky_odds'][idx] ? `(★X${commonResult['bet_area_odds'][idx]})` : ''
}

const BetAreaDisplay = {
    UpDown: ['big', 'small'],
    UpDownV2: ['big', 'small'],
    DuelSoccer: ['shoot', 'shootLeft', 'shootMiddle', 'shootRight', 'defense', 'defenseLeft', 'defenseMiddle', 'defenseRight'],
    SnailRacingSlow: ['r1', 'g1', 'b1', 'r12', 'g12', 'b12', 'rgb', 'rbg', 'grb', 'gbr', 'brg', 'bgr'],
    SnailRacing: ['r1', 'g1', 'b1', 'r12', 'g12', 'b12', 'rgb', 'rbg', 'grb', 'gbr', 'brg', 'bgr'],
    Ladder: ['left', 'right', 'odd', 'even', 'threeLines', 'fourLines', 'singleThreeLines', 'singleFourLines', 'doubleThreeLines', 'doubleFourLines'],
    HooHeyHow: [
        'allTriple',
        'fish',
        'shrimp',
        'gourd',
        'coin',
        'crab',
        'chicken',
        'fishShrimp',
        'fishGourd',
        'fishCoin',
        'fishCrab',
        'fishChicken',
        'shrimpGourd',
        'shrimpCoin',
        'shrimpCrab',
        'shrimpChicken',
        'gourdCoin',
        'gourdCrab',
        'gourdChicken',
        'coinCrab',
        'coinChicken',
        'crabChicken',
    ],
    ColorPlate: ['even', 'odd', '0', '1', '3', '4'],
    ColorPlateV2: ['even', 'odd', '0', '1', '3', '4'],
    ShaiZiSanGong: ['banker', 'tie', 'player'],
    BaccaratLZ: ['banker', 'player', 'tie', 'bankerPair', 'playerPair', 'big', 'small'],
    FanTan: [
        'fan1',
        'fan2',
        'fan3',
        'fan4',
        'odd',
        'even',
        'corner12',
        'corner23',
        'corner34',
        'corner14',
        'call12',
        'call13',
        'call14',
        'call21',
        'call23',
        'call24',
        'call31',
        'call32',
        'call34',
        'call41',
        'call42',
        'call43',
        'door123',
        'door234',
        'door124',
        'door134',
    ],
    PokDeng: ['spade', 'heart', 'clubs', 'diamond'],
    CockFighting: [
        'home',
        'away',
        'instantSkill',
        'tie',
        'odd',
        'even',
        'point12',
        'point23',
        'point34',
        'point45',
        '0:0',
        '0:1',
        '0:2',
        '0:3',
        '1:0',
        '1:1',
        '1:2',
        '1:3',
        '2:0',
        '2:1',
        '2:2',
        '2:3',
        '3:0',
        '3:1',
        '3:2',
        'big05',
        'big15',
        'big25',
        'big35',
        'big45',
        'small05',
        'small15',
        'small25',
        'small35',
        'small45',
    ],
    ColorGame: ['yellow', 'white', 'pink', 'blue', 'red', 'green'],
    RedBlackLZ: ['red', 'black', 'lucky'],
    DragonTiger: ['dragon', 'tiger', 'tie'],
    SicBoTha: [
        'big',
        'small',
        '11',
        'dice_1',
        'dice_2',
        'dice_3', // idx = 5
        'dice_4',
        'dice_5',
        'dice_6',
        '12',
        '14', // idx = 10
        '15',
        '16',
        '23',
        '24',
        '25', // idx = 15
        '26',
        '34',
        '35',
        '36',
        '45', // idx = 20
        '56',
        'small_1',
        'big_6',
        'small_3',
        'big_4', // idx = 25
        'small_5',
        'small_6',
        '123',
        '456',
    ],
    CockFighting2: ['dragon', 'tie', 'big_tie', 'phoenix'],
    BullBullHundredLZ: ['land', 'water', 'fire', 'wind'],
    MouseGetsFortune: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20'],
    FortuneDice: ['banker', 'tie', 'player'],
    HundredsTeenPatti: [
        "banker",
        "bankerStraightFlush",
        "banker3OfAKind",
        "bankerStraight",
        "bankerFlush",
        "bankerPair",
        "player",
        "playerStraightFlush",
        "player3OfAKind",
        "playerStraight",
        "playerFlush",
        "playerPair",
        "tie",
    ],
    GarudaGod: ["left", "right"],
    DeepSeaAdventure: [],
    SuperSicBo888: [
        "small",
        "big",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "dice1",
        "dice2",
        "dice3",
        "dice4",
        "dice5",
        "dice6",
        "craps1",
        "craps2",
        "craps3",
        "craps4",
        "craps5",
        "craps6",
        "crapsGroup12",
        "crapsGroup13",
        "crapsGroup14",
        "crapsGroup15",
        "crapsGroup16",
        "crapsGroup23",
        "crapsGroup24",
        "crapsGroup25",
        "crapsGroup26",
        "crapsGroup34",
        "crapsGroup35",
        "crapsGroup36",
        "crapsGroup45",
        "crapsGroup46",
        "crapsGroup56",
        "surround1",
        "surround2",
        "surround3",
        "surround4",
        "surround5",
        "surround6",
        "surround"
    ],
    SicBoTha2: [
        "big", // idx = 0
        "small",
        "11",
        "dice_1",
        "dice_2",
        "dice_3", // idx = 5
        "dice_4",
        "dice_5",
        "dice_6",
        "12",
        "13", // idx = 10
        "14",
        "15",
        "16",
        "23",
        "24", // idx = 15
        "25",
        "26",
        "34",
        "35",
        "36", // idx = 20
        "45",
        "46",
        "56",
        "small_1",
        "small_2", // idx = 25
        "small_3",
        "big_3",
        "small_4",
        "big_4",
        "small_5", // idx = 30
        "big_5",
        "small_6",
        "big_6",
        "123",
        "456" // idx = 35
    ],
    AviatorX: ["left", "right"],
    EDMBigAndSmall: ['big', 'small'],
    Aviator: ["left", "right"],
    LuckySicBo: [
        "small",
        "big",
        "odd",
        "even",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "single_dice_1",
        "single_dice_2",
        "single_dice_3",
        "single_dice_4",
        "single_dice_5",
        "single_dice_6",
        "double_1",
        "double_2",
        "double_3",
        "double_4",
        "double_5",
        "double_6"
    ],
    CyberpunkColorDisc: ['even', 'odd', '0', '1', '3', '4','O','X','right','down','up','left']
}

const CommonResultType = {
    UpDown: { type: COMMON_RESULT_TYPE_CUSTOMIZE, key: 'dice_value' },
    UpDownV2: { type: COMMON_RESULT_TYPE_CUSTOMIZE, key: 'dice_value' },
    DuelSoccer: {
        type: COMMON_RESULT_TYPE_BET_AREA_MULTI,
        key: 'lottery_results',
    },
    SnailRacingSlow: {
        type: COMMON_RESULT_TYPE_BET_AREA_SINGLE,
        key: 'lottery_results',
        startIdx: 6,
    },
    SnailRacing: {
        type: COMMON_RESULT_TYPE_BET_AREA_SINGLE,
        key: 'lottery_results',
        startIdx: 6,
    },
    Ladder: { type: COMMON_RESULT_TYPE_BET_AREA_MULTI, key: 'lottery_results' },
    HooHeyHow: { type: COMMON_RESULT_TYPE_CUSTOMIZE, key: 'dice_value' },
    ColorPlate: { type: COMMON_RESULT_TYPE_CUSTOMIZE, key: 'plates_color' },
    ColorPlateV2: { type: COMMON_RESULT_TYPE_CUSTOMIZE, key: 'plates_color' },
    ShaiZiSanGong: {
        type: COMMON_RESULT_TYPE_BET_AREA_MULTI,
        key: 'lottery_results',
    },
    BaccaratLZ: {
        type: COMMON_RESULT_TYPE_BET_AREA_MULTI,
        key: 'lottery_results',
    },
    FanTan: {
        type: COMMON_RESULT_TYPE_BET_AREA_MULTI,
        key: 'lottery_results',
    },
    PokDeng: {
        type: COMMON_RESULT_TYPE_BET_AREA_MULTI,
        key: 'lottery_results',
        allFalseDisplay: '莊家通殺',
    },
    CockFighting: {
        type: COMMON_RESULT_TYPE_BET_AREA_MULTI,
        key: 'lottery_results',
    },
    CockFighting2: {
        type: COMMON_RESULT_TYPE_BET_AREA_MULTI,
        key: 'lottery_results',
    },
    ColorGame: {
        type: COMMON_RESULT_TYPE_CUSTOMIZE,
        key: 'dice_value',
    },
    RedBlackLZ: {
        type: COMMON_RESULT_TYPE_BET_AREA_MULTI,
        key: 'bet_area_result',
    },
    DragonTiger: {
        type: COMMON_RESULT_TYPE_BET_AREA_MULTI,
        key: 'lottery_results',
    },
    SicBoTha: {
        type: COMMON_RESULT_TYPE_BET_AREA_MULTI,
        key: 'lottery_results',
    },
    BullBullHundredLZ: {
        type: COMMON_RESULT_TYPE_BET_AREA_MULTI,
        key: 'lottery_results',
    },
    MouseGetsFortune: {
        type: COMMON_RESULT_TYPE_BET_AREA_MULTI,
        key: 'bet_area_result',
    },
    FortuneDice: {
        type: COMMON_RESULT_TYPE_BET_AREA_MULTI,
        key: 'lottery_results',
    },
    HundredsTeenPatti: {
        type: COMMON_RESULT_TYPE_BET_AREA_MULTI,
        key: 'lottery_results',
    },
    GarudaGod: {
        type: COMMON_RESULT_TYPE_TIME,
        key: ['odds_final_fly_out', 'final_flyout_odds'],
    },
    DeepSeaAdventure: {
        type: COMMON_RESULT_TYPE_TIME,
        key: 'odds_explosion',
    },
    SuperSicBo888: {
        type: COMMON_RESULT_TYPE_BET_AREA_MULTI,
        key: 'lottery_results',
    },
    SicBoTha2: {
        type: COMMON_RESULT_TYPE_BET_AREA_MULTI,
        key: 'lottery_results',
    },
    AviatorX: {
        type: COMMON_RESULT_TYPE_TIME,
        key: ['odds_final_fly_out', 'final_flyout_odds'],
    },
    EDMBigAndSmall: { type: COMMON_RESULT_TYPE_CUSTOMIZE, key: 'dice_value' },
    Aviator: {
        type: COMMON_RESULT_TYPE_TIME,
        key: ['odds_final_fly_out', 'final_flyout_odds'],
    },
    LuckySicBo: {
        type: COMMON_RESULT_TYPE_BET_AREA_MULTI,
        key: 'lottery_results',
    },
    CyberpunkColorDisc: { type: COMMON_RESULT_TYPE_CUSTOMIZE, key: 'plates_color' }
}

const CommonResultValuesDisplay = {
    UpDown: ['', '1', '2', '3', '4', '5', '6'],
    UpDownV2: ['', '1', '2', '3', '4', '5', '6'],
    HooHeyHow: ['', 'fish', 'shrimp', 'gourd', 'coin', 'crab', 'chicken'],
    ColorPlate: { red: 'red', white: 'white' },
    ColorPlateV2: { red: 'red', white: 'white' },
    ColorGame: ['', 'yellow', 'white', 'pink', 'blue', 'red', 'green'],
    BullBullHundredLZ: { land: 'land', water: 'water', fire: 'fire', wind: 'wind' },
    MouseGetsFortune: ['', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20'],
    EDMBigAndSmall: ['', '1', '2', '3', '4', '5', '6'],
    CyberpunkColorDisc: { red: 'blue', white: 'white' }
}

/** 有效投注計算 */
export function handleBetValid (gameCode, betValue, betProfit) {
	/** 全退遊戲 */
	const allBack = ['BaccaratLZ', 'FanTan']
	/** 退50%遊戲 */
	const halfBack = ['ShaiZiSanGong', 'DragonTiger']
	/** 和局全退 */
	if (allBack.includes(gameCode)) {
			return 0
	}
	/** 和局退50% */
	if (halfBack.includes(gameCode)) {
			return Number(new Decimal(betValue).add(betProfit))
	}
	return betValue
}

const LuckyMultiplierGameList = ['SuperSicBo888', 'LuckySicBo']

/** 與下注區域分割客製化開獎結果 */
const CustomLotteryResultsDisplay = ['LuckySicBo']

const LotteryResultsDisplay = {
    LuckySicBo: [
        "small",
        "big",
        "odd",
        "even",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "single_dice_1",
        "single_dice_2",
        "single_dice_3",
        "single_dice_4",
        "single_dice_5",
        "single_dice_6",
        "dice_1",
        "dice_2",
        "dice_3",
        "dice_4",
        "dice_5",
        "dice_6",
        "double_1",
        "double_2",
        "double_3",
        "double_4",
        "double_5",
        "double_6",
        "dice_1x2",
        "dice_2x2",
        "dice_3x2",
        "dice_4x2",
        "dice_5x2",
        "dice_6x2",
        "dice_1x3",
        "dice_2x3",
        "dice_3x3",
        "dice_4x3",
        "dice_5x3",
        "dice_6x3"
    ]
}